import ButtonBase from '@mui/material/ButtonBase';

type Props = { page: number; onOpen: (page: number) => void };

/** "p.3": opens the report at that page. */
export function PageCite({ page, onOpen }: Props) {
  return (
    <ButtonBase onClick={(e) => { e.stopPropagation(); onOpen(page); }} aria-label={`Open page ${page}`} sx={citeChipSx}>
      p.{page}
    </ButtonBase>
  );
}

export const citeChipSx = {
  flexShrink: 0,
  height: 18,
  px: 0.625,
  borderRadius: 0.5,
  fontSize: '0.6875rem',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  bgcolor: 'surface.accentSoft',
  color: 'primary.main',
  transition: 'background-color 120ms, color 120ms',
  '&:hover': { bgcolor: 'primary.main', color: 'primary.contrastText' },
} as const;
